import axiosInstance from "../../../services/axiosInstance";
import axiosInstanceMultipart from "../../../services/axiosInstanceMultipart";
import axiosInstanceNoToken from "../../../services/axiosInstanceNoToken";


export const getUserInfo = async (request = {}) => {
    const response = await axiosInstance.get('users/profiles/info',  request );
    return response.data;
};

export const getContractors = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('users/profiles', {params} );
    return response.data;
};

export const getContent = async (slug) => {
    const response = await axiosInstanceNoToken.get(`contents/${slug}` );
    return response.data;
};

export const getWalletDetail = async (params = null) => {
    const response = await axiosInstance.get(`wallets/transactions`,{params} );
    return response.data;
};

export const getReagents = async (params = null) => {
    const response = await axiosInstance.get(`users/reagents`,{params} );
    return response.data;
};

export const updateProfile = async (request = null) => {
    const response = await axiosInstanceMultipart.post('users/update-profile',request  );
    return response.data;
};

export const getOrganizationInfo = async (params = null) => {
    const response = await axiosInstanceNoToken.get('organization', {params}  );
    return response.data;
};

export const getProducers = async (params = null) => {
    const response = await axiosInstanceNoToken.get('products/producers', {params}  );
    return response.data;
};

export const getProducer = async (id, params = null) => {
    const response = await axiosInstanceNoToken.get('products/producers/' + id, {params}  );
    return response.data;
};
